import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
  Box,
  CssBaseline,
  ListItemIcon,
  Collapse,
  ListItemButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { logout } from "../api/authApi";
import {
  Build,
  Business,
  CarCrash,
  Checklist,
  Engineering,
  Factory,
  Group,
  Groups,
  Home,
  Logout,
  ExpandLess,
  ExpandMore,
  NoCrash,
  MinorCrash,
  CompareArrows,
} from "@mui/icons-material";

const drawerWidth = 240;

interface MenuItem {
  text: string;
  icon: React.ReactNode;
  path: string;
  divider?: boolean;
  action?: () => void;
  children?: MenuItem[];
}

const Sidebar: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [openEntregaImpecavel, setOpenEntregaImpecavel] = useState(false);
  const [activePath, setActivePath] = useState<string>(
    window.location.pathname
  );
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleLogout = async () => {
    try {
      await logout();
      localStorage.clear();
      setTimeout(() => {
        navigate("/");
      }, 800);
    } catch (error) {
      console.error("Erro ao fazer logout:", error);
    }
  };

  const handleNavigation = (path: string) => {
    setActivePath(path);
    navigate(path);
    if (window.innerWidth < 960) {
      setIsDrawerOpen(false);
    }
  };

  const handleToggleEntregaImpecavel = () => {
    setOpenEntregaImpecavel(!openEntregaImpecavel);
  };

  const menuItems: MenuItem[] = [
    { text: "Início", icon: <Home />, path: "/dashboard" },
    { text: "Grupos", icon: <Groups />, path: "/grupo" },
    { text: "Empresas", icon: <Business />, path: "/empresas" },
    { text: "Ferramentas", icon: <Build />, path: "/ferramenta" },
    { text: "Checklists", icon: <Checklist />, path: "/checklists" },
    { text: "Usuários", icon: <Group />, path: "/usuarios" },
    { text: "Tipos", icon: <Engineering />, path: "/tipos" },
    { divider: true, text: "", icon: null, path: "" },
    {
      text: "Entrega Impecável",
      icon: <CarCrash />,
      path: "#",
      children: [
        { text: "Veículos", icon: <CarCrash />, path: "/veiculos" },
        { text: "Fabricantes", icon: <Factory />, path: "/fabricantes" },
        { text: "Modelos", icon: <NoCrash />, path: "/modelos" },
        { text: "Ações", icon: <MinorCrash />, path: "/acoes" },
        {
          text: "Transferir Ações",
          icon: <CompareArrows />,
          path: "/acoesTrasnferir",
        },
      ],
    },
    { text: "Logout", icon: <Logout />, path: "", action: handleLogout },
  ];

  const renderMenuItem = (item: MenuItem, index: number) => (
    <React.Fragment key={index}>
      {item.divider ? (
        <Divider />
      ) : (
        <>
          <ListItem disablePadding>
            <ListItemButton
              onClick={
                item.children
                  ? handleToggleEntregaImpecavel
                  : item.action
                  ? item.action
                  : () => handleNavigation(item.path)
              }
              sx={{
                backgroundColor:
                  activePath === item.path ? "rgba(0, 0, 0, 0.08)" : "inherit",
              }}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
              {item.children ? (
                openEntregaImpecavel ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )
              ) : null}
            </ListItemButton>
          </ListItem>

          {item.children && (
            <Collapse in={openEntregaImpecavel} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {item.children.map((childItem, childIndex) => (
                  <ListItem disablePadding key={childIndex}>
                    <ListItemButton
                      sx={{
                        pl: 4,
                        backgroundColor:
                          activePath === childItem.path
                            ? "rgba(0, 0, 0, 0.08)"
                            : "inherit",
                      }}
                      onClick={() => handleNavigation(childItem.path)}
                    >
                      <ListItemIcon>{childItem.icon}</ListItemIcon>
                      <ListItemText primary={childItem.text} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </Collapse>
          )}
        </>
      )}
    </React.Fragment>
  );

  const drawerContent = (
    <div>
      <Toolbar />
      <Divider />
      <List>{menuItems.map((item, index) => renderMenuItem(item, index))}</List>
    </div>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            Sistema Interno
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="persistent"
        open={isDrawerOpen}
        sx={{
          flexShrink: 0,
          width: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            transition: "width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
          },
        }}
      >
        {drawerContent}
      </Drawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          transition: "margin-left 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
          marginLeft: isDrawerOpen ? 30 : 0,
          width: "100%",
        }}
      >
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};

export default Sidebar;
